import React, {useState, useEffect} from 'react';
import {FiEdit} from "react-icons/fi";
import { useHistory } from 'react-router-dom';
import {TouchableHighlight, Container} from '_atoms';
import { RewardDetail } from '_molecules';
import { Colors, Spacing, Typography } from '_styles';
import Expand from 'react-expand-animated';
import { useSelector, useDispatch, } from 'react-redux';
import { selectRewards, selectRewardsStatus, fetchRewards } from '_redux/slices/prm-club/rewards';
import {AiOutlinePlusCircle} from "react-icons/ai";


const CreateRewardTile = (props) => {

    return (
        <>
            <div style={{ height:650, width:320 }}>

                {/* Image */}
                <TouchableHighlight height={230} width={290} onClick={()=>{props.handleClick('create')}} >
                
                    <div 
                        style={{
                            width:'100%',
                            height:'100%',
                            borderRadius:20,
                            boxShadow: "0px 4px 8px 0px #9E9E9E",
                            textAlign:'center', 
                        }}
                    >
                    <AiOutlinePlusCircle size={50} style={{padding:2, marginTop: '40%'}} color='#307FE2'/>
                    </div>
                </TouchableHighlight>

                {/* Title */}
                <div style={{marginLeft:25, display:'flex', marginTop:Spacing.SCALE_8, justifyContent:'space-between'}}>
                    <div>
                        <p style={{fontSize:22, fontWeight:'200'}}>Create Reward</p>
                        <p style={{fontSize:14, fontWeight:'500', opacity:0.5, marginTop:-Spacing.SCALE_8}}>Add a new PRM Reward</p>
                    </div>
                </div>

                
            </div>
        </>
    );
}


export default CreateRewardTile;